// src/components/Features.js
import React from 'react';
import { Icons } from './Icons';

const features = [
  {
    icon: Icons.Shield,
    title: 'Полная модерация',
    description: 'Бан, мут, предупреждения, заметки — всё, что нужно для порядка в чате.'
  },
  {
    icon: Icons.Zap,
    title: 'Автоматический антирейд',
    description: 'Мгновенное обнаружение массовых вступлений и защита от рейдов.'
  },
  {
    icon: Icons.Settings,
    title: 'Онлайн-панель администратора',
    description: 'Управляйте чатами через веб-интерфейс с секретным доступом.'
  },
  {
    icon: Icons.Lock,
    title: 'Капча для новых участников',
    description: 'Простая или сложная капча — защита от ботов и спамеров.'
  },
  {
    icon: Icons.MessageSquare,
    title: 'Система репортов',
    description: 'Пользователи могут сообщать о нарушителях с удобными кнопками действий.'
  },
  {
    icon: Icons.Command,
    title: 'Гибкие настройки',
    description: '25+ параметров для тонкой настройки под ваш чат.'
  },
  {
    icon: Icons.Check,
    title: 'Авто-комментарии',
    description: 'Автоматические комментарии к постам из канала.'
  },
  {
    icon: Icons.Clock,
    title: 'Авто-сообщения',
    description: 'Планирование автоматических сообщений с ротацией до 6 вариантов.'
  },
  {
    icon: Icons.Users,
    title: 'Служба поддержки',
    description: 'Встроенная система тикетов с форумами и оценками.'
  },
  {
    icon: Icons.Hash,
    title: 'Полное логирование',
    description: 'Все действия администраторов и нарушения фиксируются в JSON-логах.'
  },
  {
    icon: Icons.Check,
    title: 'Автоудаление сообщений',
    description: 'Автоматическая очистка сообщений бота и команд.'
  },
  {
    icon: Icons.User,
    title: 'Приветственные сообщения',
    description: 'Персонализированные приветствия для новых участников.'
  }
];

function Features() {
  return (
    <section id="features" className="features">
      <div className="container">
        <div className="section-header">
          <h2>Возможности Atri Bot</h2>
          <p>Всё, что нужно для идеального чата в одном месте</p>
        </div>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">
                <feature.icon />
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Features;